import { ReactNode } from "react";
import { Button } from "@/shared/ui/button";
import { useNavigate } from "react-router-dom";

interface SuccessStateProps {
  title: string;
  description: string | ReactNode;
  buttonText?: string;
  redirectTo?: string;
  icon: ReactNode;
  className?: string;
}

export function SuccessState({
  title,
  description,
  buttonText = "Voltar",
  redirectTo = "/auth",
  icon,
  className = ""
}: SuccessStateProps) {
  const navigate = useNavigate();

  return (
    <div className={`text-center space-y-6 ${className}`}>
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-green-500/10">
        {icon}
      </div>
      <h1 className="text-2xl font-semibold tracking-tight text-white">{title}</h1>
      <p className="text-white/60">{description}</p>
      <Button
        onClick={() => navigate(redirectTo)}
        className="w-full bg-[#D91657] hover:bg-[#C1174F] text-white"
      >
        {buttonText}
      </Button>
    </div>
  );
}
